import { CustomerModel, useSuspendCustomer } from 'api-hooks/customer';
import { AuthorizationRules } from 'common/constants';
import { UserStatusEnum } from 'common/constants/enum';
import notification from 'components/common/notification';
import { PopoverMenuType } from 'components/popover';
import { useAuthorization } from 'hooks/use-authorization';
import useDialog from 'hooks/use-dialog';
import useDismiss from 'hooks/use-dismiss';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

export default function useCustomerSuspendAction(customer?: CustomerModel) {
  const suspendCustomerMutate = useSuspendCustomer();
  const { t } = useTranslation();
  const dialog = useDialog();
  const onDismiss = useDismiss('customers');
  const { can } = useAuthorization();

  const id = customer?.id;

  const customerSuspendPermission =
    can(AuthorizationRules.CustomersUpdateSurveillance) &&
    customer?.status === UserStatusEnum.Safe;

  const onCustomerSuspend = React.useCallback(
    async (currentId?: string) => {
      const _id = currentId ?? id;

      const message = {
        id: _id || 'undefined',
        message: 'Invalid Customer Suspend Action (FE)',
      };

      if (!_id) {
        notification.error({
          message: JSON.stringify(message),
        });
        return;
      }

      dialog.showConfirmation({
        message: t('common:confirmation_suspend_text'),
        title: t('common:confirmation'),
        onPositiveAction: async (onClose) => {
          try {
            const result = await suspendCustomerMutate.mutateAsync({
              customerId: _id,
              body: { action: UserStatusEnum.UnderSurveillance },
            });

            notification.success({
              message: result.message,
            });
            onClose();
            onDismiss();
          } catch (error) {
            notification.error({ message: error.message });
          }
        },
        onNegativeAction: (onClose) => {
          onClose();
        },
      });
    },
    [id, dialog, t, suspendCustomerMutate, onDismiss],
  );

  const customerSuspendAction: PopoverMenuType = {
    key: `customer-suspend=${customer?.id}`,
    label: t('customer:suspend'),
    onClick: onCustomerSuspend,
    isAllowed: customerSuspendPermission,
    isError: true,
  };

  return {
    onCustomerSuspend,
    customerSuspendPermission,
    customerSuspendAction,
  };
}
